export interface MagayaConnectionStatus{
    code: string;
    message: string;
    severity: string;
    updated_at: Date|string;
}
